var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "105mm",
    height: "148mm",
    viewBox: "0 0 105 148",
    id: "svg5",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3115",
    style: {
      fill: "#2c89a0"
    },
    transform: "translate(3.460805,8.571421)"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      fontSize: "42.2864px",
      fontFamily: "'Mukta Mahee'",
      fill: "#2c89a0",
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none"
    },
    id: "rect2994",
    width: 21.944651,
    height: 8.1800842,
    x: 16.950081,
    y: 45.541046,
    ry: 0
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fontSize: "42.2864px",
      fontFamily: "'Mukta Mahee'",
      fill: "#2c89a0",
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none"
    },
    id: "rect2994-4",
    width: 11.473001,
    height: 6.8752351,
    x: 36.156513,
    y: 15.269357,
    ry: 0,
    transform: "rotate(35.330842)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fontSize: "42.2864px",
      fontFamily: "'Mukta Mahee'",
      fill: "#2c89a0",
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none"
    },
    id: "rect2994-4-1",
    width: 17.088926,
    height: 6.4883842,
    x: -13.543769,
    y: -52.819881,
    ry: 0,
    transform: "rotate(146.32945)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fontSize: "42.2864px",
      fontFamily: "'Mukta Mahee'",
      fill: "#2c89a0",
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none"
    },
    id: "rect2994-35",
    width: 21.944651,
    height: 8.1800842,
    x: 16.950081,
    y: 59.620232,
    ry: 0
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fontSize: "42.2864px",
      fontFamily: "'Mukta Mahee'",
      fill: "#2c89a0",
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none"
    },
    id: "rect2994-35-7",
    width: 21.944651,
    height: 8.1800842,
    x: 16.945307,
    y: 73.699417,
    ry: 0
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fontSize: "42.2864px",
      fontFamily: "'Mukta Mahee'",
      fill: "#2c89a0",
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none"
    },
    id: "rect2994-3",
    width: 9.8318329,
    height: 9.1239424,
    x: 16.950081,
    y: 52.108711,
    ry: 0
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fontSize: "42.2864px",
      fontFamily: "'Mukta Mahee'",
      fill: "#2c89a0",
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none"
    },
    id: "rect2994-3-9",
    width: 9.8318329,
    height: 9.1239424,
    x: 29.058125,
    y: 66.187897,
    ry: 0
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3464",
    style: {
      fill: "#d38d5f"
    },
    transform: "translate(3.738891,8.5735724)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect2994-6",
    style: {
      fontSize: "42.2864px",
      fontFamily: "'Mukta Mahee'"
    },
    d: "m 38.577724,45.538902 h 17.649039 l 3.895478,3.114566 3.921016,-3.114566 h 18.263664 v 8.227363 H 38.577724 Z"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fontSize: "42.2864px",
      fontFamily: "'Mukta Mahee'",
      fill: "#d38d5f",
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none"
    },
    id: "rect2994-35-4",
    width: 16.674788,
    height: 8.1800842,
    x: 38.577724,
    y: 59.618084,
    ry: 0
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fontSize: "42.2864px",
      fontFamily: "'Mukta Mahee'",
      fill: "#d38d5f",
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none"
    },
    id: "rect2994-35-7-0",
    width: 21.944651,
    height: 8.1800842,
    x: 38.577724,
    y: 73.697266,
    ry: 0
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fontSize: "42.2864px",
      fontFamily: "'Mukta Mahee'",
      fill: "#d38d5f",
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none"
    },
    id: "rect2994-3-8",
    width: 9.8318329,
    height: 9.1239424,
    x: 38.577724,
    y: 52.106564,
    ry: 0
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fontSize: "42.2864px",
      fontFamily: "'Mukta Mahee'",
      fill: "#d38d5f",
      stroke: "none",
      strokeWidth: 0.640291,
      strokeDasharray: "none"
    },
    id: "rect2994-3-8-7",
    width: 9.8318329,
    height: 11.640892,
    x: 72.48027,
    y: 53.483021,
    ry: 0
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fontSize: "42.2864px",
      fontFamily: "'Mukta Mahee'",
      fill: "#d38d5f",
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none"
    },
    id: "rect2994-3-9-2",
    width: 9.8318329,
    height: 9.1239424,
    x: 38.577724,
    y: 66.185745,
    ry: 0
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#d38d5f",
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none"
    },
    id: "rect3257",
    width: 0.55058259,
    height: 0.078654654,
    x: 76.21637,
    y: 66.618347
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect3259",
    style: {
      fill: "#d35f5f",
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none"
    },
    d: "M 63.985573,64.415883 V 81.87735 h 18.32653 V 64.415883 Z m 5.938139,5.233339 h 6.449736 v 6.842994 h -6.449736 z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.e9cc64fe0202e82ab67f783563790124.svg";
export { ForwardRef as ReactComponent };